import { Injectable } from '@angular/core';
import { from as fromNgRx, Observable, of, take } from 'rxjs';
import { PRODUCT_TYPES } from '@pos-common/constants/product-types';
import { UPDATES_TYPES } from '@pos-common/constants/updates-types.const';
import { DbDaoService } from '@pos-common/services/db/db-dao.service';
import { Product } from '@pos-common/classes/product.class';
import { map, switchMap } from 'rxjs/operators';
import { DbResponse } from '@pos-common/services/db/db-dao.utils';
import { ProductVariant } from '@pos-common/classes/product-variant.class';
import { InvoicesService } from '@pos-common/services/system/invoices.service';

@Injectable()
export class DepositService {

  constructor(
    private dbDaoService: DbDaoService,
    private invoicesService: InvoicesService
  ) {}

  getDeposits(): Observable<Product[]> {
    return fromNgRx(this.dbDaoService.getAllData<Product[]>(UPDATES_TYPES.Product.type,  { deleted: false, type: PRODUCT_TYPES.DEPOSIT }))
      .pipe(
        map(({ data }): Product[] => data),
        take(1));
  }

  getDepositById(id: number): Observable<[Product, ProductVariant]> {

    return this.getDeposits().pipe(
      switchMap((products: Product[]) => {
        const deposit: Product = products.find((item: Product): boolean => item?.["id"] === id);
        const isValidDepositProduct: boolean = Boolean(deposit && deposit.variants && deposit.variants?.[0]);
        return isValidDepositProduct
          ? fromNgRx(this.dbDaoService.getDataByUUID(UPDATES_TYPES.ProductVariant.type, deposit.variants[0].uuid)).pipe(
              map((variant: DbResponse<ProductVariant>): [Product, ProductVariant] => [deposit, variant.data]),
              take(1)
            )
          : of([deposit, null]);
      }),
      map(([product, variant]: [Product, ProductVariant]): [Product, ProductVariant] =>
        product && variant ? [new Product(product), new ProductVariant(variant)] : [null, null]
      ),
      take(1)
    );
  }

  addDepositByProductUuid(id: number, uuidProductWithDeposit: string, uuidDeposit: string): Observable<any> {
    return this.getDepositById(id)
      .pipe(
        take(1),
        map(([depositProduct, depositVariant]: [Product, ProductVariant]): void => {
          const dataToAdd = this.invoicesService.makeInvoiceEntryToAddData(depositVariant, depositProduct, '', 'root');
          dataToAdd.isDesositEntry = true;
          dataToAdd.uuidDeposit = uuidDeposit;
          dataToAdd.uuidProductWithDeposit = uuidProductWithDeposit;
          return dataToAdd
        })
      );
  }

}
